<template>
  <div>
    <ts-page-title
      :title="$t('payrollCycleDate.pageTitle')"
      :breadcrumb="[
        { text: $t('home'), href: '/' },
        {
          text: $t('payrollCycleDate.pageTitle'),
          active: true,
        },
      ]"
    />
    <ts-panel>
      <ts-panel-wrapper class="tw-flex tw-items-center tw-justify-between">
        <a-button type="primary" @click="addNew">
          {{ $t("addNew") }}
        </a-button>
        <div class="tw-justify-end">
          <a-input
            v-model="search"
            v-tooltip="$t('payrollCycleDate.search')"
            :placeholder="$t('search')"
            style="width: 250px"
            class="inline-block"
          />
        </div>
      </ts-panel-wrapper>
      <ts-table :columns="columns" :records="resources" :loading="loading">
        <template v-slot="{ record }">
          <td>{{ record.pc_date_name }}</td>
          <td class="tw-text-center">{{ record.day_from }}</td>
          <td class="tw-text-center">{{ record.day_to }}</td>
          <td class="tw-text-center tw-items-center">
            <span class="tw-text-green-500" v-if="record.monthly_based">
              <a-icon type="check-circle" class="tw-text-lg" />
            </span>
            <span v-else class="tw-text-red-500">
              <a-icon type="close-circle" class="tw-text-lg" />
            </span>
          </td>
          <td class="text-center tw-space-x-3">
            <a
              href="#"
              v-tooltip="$t('edit')"
              class="text-primary mr-2"
              @click.prevent="edit(record)"
            >
              <i class="fas fa-edit"></i>
            </a>
            <a-popconfirm
              placement="leftTop"
              :title="$t('are_you_sure_to_delete')"
              :ok-text="$t('yes')"
              :cancel-text="$t('no')"
              @confirm="deleteRecord(record)"
            >
              <a href="#" :disabled="record._deleting">
                <i class="fas fa-circle-notch spin" v-if="record._deleting"></i>
                <i class="fa fa-trash text-red" v-else></i>
              </a>
            </a-popconfirm>
          </td>
        </template>
      </ts-table>
      <div class="d-flex justify-content-end tw-p-4">
        <ts-pagination
          v-model="pagination"
          @navigate="fetchData"
        ></ts-pagination>
      </div>
    </ts-panel>

    <!-- form-action -->
    <a-modal
      v-if="showForm"
      v-model="showForm"
      :title="$t('payrollCycleDate.pageTitle')"
      centered
      :maskClosable="false"
      @cancel="clearEdit"
      :zIndex="1020"
      :footer="null"
    >
      <from-action @cancel="clearEdit" />
    </a-modal>
  </div>
</template>

<script>
import { debounce } from "lodash";
import { mapState } from "vuex";
import FromAction from "./form";

export default {
  name: "payrollCycleDateIndex",
  components: {
    FromAction,
  },
  data() {
    return {
      loading: false,
      showForm: false,
    };
  },
  computed: {
    ...mapState("humanResource/payrollCycleDate", ["resources", "pagination"]),
    search: {
      get() {
        return this.$store.state.humanResource.payrollCycleDate.search;
      },
      set(newValue) {
        this.$store.commit(
          "humanResource/payrollCycleDate/SET_SEARCH",
          newValue
        );
        this.$store.commit("humanResource/payrollCycleDate/RESET_CURRENT_PAGE");
      },
    },
    columns() {
      return [
        { name: this.$t("payrollCycleDate.pcDateName") },
        {
          name: this.$t("payrollCycleDate.dayFrom"),
          style: "text-align:center",
        },
        { name: this.$t("payrollCycleDate.dayTo"), style: "text-align:center" },
        {
          name: this.$t("payrollCycleDate.monthlyBased"),
          style: "text-align:center",
        },
        {
          name: this.$t("actions"),
          style: "text-align:center; width: 1px;",
        },
      ];
    },
  },
  methods: {
    fetchData(attributes) {
      this.loading = true;
      this.$store
        .dispatch("humanResource/payrollCycleDate/fetch", { ...attributes })
        .then(() => {
          this.loading = false;
        })
        .catch((error) => {
          this.loading = false;
          this.$notify({ type: "error", text: error.message });
        });
    },
    addNew() {
      this.showForm = true;
    },
    edit(record) {
      this.$store.commit(
        "humanResource/payrollCycleDate/SET_EDIT_DATA",
        record
      );
      this.showForm = true;
    },
    clearEdit() {
      this.$store.commit("humanResource/payrollCycleDate/SET_EDIT_DATA", {});
      this.showForm = false;
      this.fetchData();
    },
    deleteRecord(record) {
      record._deleting = true;
      this.$store
        .dispatch("humanResource/payrollCycleDate/destroy", record.pc_date_id)
        .then((response) => {
          this.$notify({ type: "success", text: response.message });
          this.fetchData();
        })
        .catch((error) => {
          this.$notify({ type: "error", text: error.message });
        })
        .finally(() => {
          record._deleting = false;
        });
    },
  },
  watch: {
    search: debounce(function () {
      this.fetchData();
    }, 500),
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.fetchData();
    });
  },
  beforeRouteLeave(to, from, next) {
    this.$store.commit("humanResource/payrollCycleDate/RESET_STATE");
    next();
  },
};
</script>
